var AlignVAT = /* @__PURE__ */ ((AlignVAT2) => {
  AlignVAT2["RIGHT"] = "right";
  AlignVAT2["BOTTOM"] = "bottom";
  return AlignVAT2;
})(AlignVAT || {});

export { AlignVAT };
//# sourceMappingURL=ep-pricing-esm-types-vat.types.js.map
